import { Box, Theme, Typography } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import NavLogo from '../../images/NavLogo.svg';
import { Search } from '../../components/Search';
import { ThemedDatePicker } from '../../components/Form';
import { Formik } from 'formik';
import { HeaderFilter } from '../../../types';
import { useContext, useEffect, useState } from 'react';
import UserContext from '../../context/user';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    navBottom: {
      paddingTop: theme.spacing(3.25),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(4),
      paddingBottom: theme.spacing(3),
      backgroundColor: theme.palette.grey[100],
    },
    dateRoot: {
      backgroundColor: 'white',
    },
  })
);

// showDateFilter: the from/to date range only drives the Overview stats; pages
// like Pending Requests ignore it, so they hide the pickers.
const HeaderBottom = ({ subtext, showDateFilter = true }: { subtext: string; showDateFilter?: boolean }) => {
  const classes = useStyles();
  const { setHeaderFilter } = useContext(UserContext);
  const [filter, setFilter] = useState<HeaderFilter>({
    fromDate: '',
    toDate: '',
    searchText: '',
  });
  useEffect(() => {
    setHeaderFilter(filter);
  }, [filter, setHeaderFilter]);

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      flexWrap="wrap"
      gap={2}
      className={classes.navBottom}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <img src={NavLogo} alt="Logo" height={40} />
        <Typography variant="h4" sx={{ color: '#00ACC1' }}>
          {subtext}
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" gap={2}>
        <Formik initialValues={filter} onSubmit={() => {}} enableReinitialize>
          {() => {
            const handleSelectChange = (e: { target: { name: string; value: string } }) => {
              if (e.target.name === 'fromDate' || e.target.name === 'toDate') {
                const _filter = { ...filter };
                _filter[e.target.name as 'fromDate' | 'toDate'] = e.target.value;
                setFilter(_filter);
              }
            };
            return (
              <>
                {showDateFilter ? (
                  <>
                    <Box width={170}>
                      <ThemedDatePicker
                        label="From Date"
                        textFieldVariant="outlined"
                        name="fromDate"
                        textFieldClassName={classes.dateRoot}
                        textFieldSize="small"
                        onChange={handleSelectChange}
                      />
                    </Box>
                    <Box width={170}>
                      <ThemedDatePicker
                        label="To Date"
                        textFieldVariant="outlined"
                        name="toDate"
                        textFieldClassName={classes.dateRoot}
                        textFieldSize="small"
                        onChange={handleSelectChange}
                      />
                    </Box>
                  </>
                ) : null}
                <Box width={240}>
                  <Search bgColor="white" name="searchText" placeholder="Search..." onChange={() => {}} />
                </Box>
              </>
            );
          }}
        </Formik>
      </Box>
    </Box>
  );
};

export default HeaderBottom;
